// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__OKV0h","errorLogs":"EditorFooter_errorLogs__3CQct"};